// extracted by mini-css-extract-plugin
export default {"ToolbarDiv":"EditPromotionDialog_ToolbarDiv__HE8B1","Label":"EditPromotionDialog_Label__WsoF1","BottomMargin":"EditPromotionDialog_BottomMargin__RaoE9"};